export const TABS = {
    dashboard: 'dashboard',
    general: 'general',
    golf: 'golf',
    marketing: 'marketing',
    finances: 'finances',
    activity: 'activity',
    access: 'access',
    specialProducts: 'specialProducts',
    webapp: 'webapp',
    custFields: 'custFields',
    // Business customer specific tabs below
    staff: 'staff'
};
